import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/About.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/CoreValue.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/FamilyIntro.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AboutPageClient"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/HeroBanner/AboutPageClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/HistoryAbout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/OurFarm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/Testimonial.tsx");
